<template lang="pug">
  .v-toggler(@click="toggle")
    i.i-arrow-down(:style="styles")
</template>

<script>
export default {
  name: 'VToggler',

  props: {
    value: Boolean
  },

  methods: {
    toggle () {
      this.$emit('input', !this.value)
    }
  },

  computed: {
    styles () {
      return {
        transform: `rotate(${this.value ? -180 : 0}deg)`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .v-toggler {
    cursor: pointer;
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      transition: .3s;
    }
  }
</style>
